/**
 * PostData 类型和 Schema 定义
 *
 * ⚠️ 注意: 此文件由脚本自动生成，请勿手动修改
 * 如需更新，请运行代码生成脚本
 */
import type { SchemaDefinition } from './_schema'
import type { PostInfo } from './post_info'
import type { PostStats } from './post_stats'
import type { UserData } from './user_data'

/**
 * PostData
 */
export interface PostData {
  /** 帖子ID */
  id?: string
  /** 帖子基础信息 */
  info?: PostInfo
  /** 作者信息 */
  author?: UserData
  /** 统计信息 */
  stats?: PostStats
}

/**
 * PostData Schema
 */
export const PostDataSchema: SchemaDefinition = {
  properties: {
    id: {
      description: '帖子ID',
      format: 'string',
      type: 'string',
      label: '帖子ID',
    },
    info: {
      $ref: 'PostInfo',
      description: '帖子基础信息',
      label: '帖子基础信息',
    },
    author: {
      $ref: 'UserData',
      description: '作者信息',
      label: '作者信息',
    },
    stats: {
      $ref: 'PostStats',
      description: '统计信息',
      label: '统计信息',
    },
  },
  type: 'object',
}
